<template>
    <a class="logo-wrapper d-none d-xl-block" :class="{ condensed : isCondensed }" :href="target">
        <div class="logo">
            <span>
                <img :src="primary" class="img-fluid">
            </span>
            <span>
                <img :src="secondary" class="img-fluid">
            </span>
        </div>
    </a>
</template>

<script>
    export default {
        props: ['primary', 'secondary', 'target'],
        data() {
            return {
                isCondensed : false,
            }
        },
        methods: {
            handleScroll(event) {
                var doc = document.documentElement;
                var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

                if (top > 80) {
                    this.isCondensed = true;
                } else {
                    this.isCondensed = false;
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        }
    }
</script>
